import React from 'react';
import {BottomTabHeaderProps} from '@react-navigation/bottom-tabs';

import BrandHeader, {BrandHeaderProps} from '../../components/BrandHeader';

export const header =
  (headerConfig: BrandHeaderProps['config']) =>
  ({navigation, route}: BottomTabHeaderProps) =>
    <BrandHeader navigation={navigation} route={route} config={headerConfig} />;
